import React from 'react';

const DialogContext = React.createContext(null);

export const useDialog = () => React.useContext(DialogContext);

export default DialogContext;
